import React, { useState } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { exportRowsToExcel } from '../utils/exportExcel';

/**
 * Botón estándar de exportación a Excel para los listados del CMDB.
 *
 * El listado es quien decide qué filas y con qué columnas se exporta: le pasa
 * un array de objetos con las cabeceras legibles como claves y este botón se
 * encarga del fichero (y del estado "Exportando…").
 *
 * @param {Array<Object>} rows       filas a exportar (cabeceras legibles como claves)
 * @param {string} fileBase          nombre base del fichero (sin fecha ni extensión)
 * @param {string} sheetName         nombre de la hoja del Excel
 * @param {string} className         clase del botón (por defecto el de las toolbars wol-*)
 * @param {boolean} disabled         fuerza el estado deshabilitado (además de rows vacío)
 * @param {string} label             texto del botón
 * @param {boolean} iconOnly         solo el icono (pantallas bajas, donde cada píxel de ancho cuenta)
 */
export default function ExportExcelButton({
  rows,
  fileBase = 'listado',
  sheetName = 'Listado',
  className = 'wol-btn-secondary',
  disabled = false,
  label = '⬇ Exportar Excel',
  iconOnly = false,
  title = 'Descargar el listado en Excel (.xlsx)'
}) {
  const [busy, setBusy] = useState(false);
  const ready = !disabled && Array.isArray(rows) && rows.length > 0;

  const handleClick = async () => {
    setBusy(true);
    try {
      await exportRowsToExcel(rows, { fileBase, sheetName });
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      disabled={busy || !ready}
      title={busy ? 'Exportando…' : title}
      aria-label={label}
    >
      {iconOnly
        ? <ArrowDownTrayIcon style={{ width: 16, height: 16 }} />
        : (busy ? 'Exportando…' : label)}
    </button>
  );
}
